import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", {
  class: "t-icon t-icon-support"
}, null, -1);
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "提交成功", -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "专属广告经理会在1~2个工作日内联系您", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_client_only = _resolveComponent("client-only");
  return _openBlock(), _createBlock(_component_client_only, null, {
    default: _withCtx(() => [_createVNode(_component_el_dialog, {
      modelValue: _ctx.isDialogVisibled,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.isDialogVisibled = $event),
      "modal-class": "submit-success-dialog",
      width: "552px",
      onClosed: _ctx.closeDialog
    }, {
      default: _withCtx(() => [_hoisted_1, _hoisted_2, _hoisted_3, _createVNode(_component_el_button, {
        class: "submit-btn",
        size: "large",
        type: "primary",
        onClick: _cache[0] || (_cache[0] = $event => {
          _ctx.router.push({
            path: '/'
          });
        })
      }, {
        default: _withCtx(() => [_createTextVNode(" 返回官网首页 ")]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue", "onClosed"])]),
    _: 1
  });
}